var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: _vm.form.id ? "修改游戏" : "新增游戏" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "视频名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入游戏名称" },
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.language,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "language", $$v)
                        },
                        expression: "form.language"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" }
                      }),
                      _c("el-option", { attrs: { label: "英语", value: "en" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1, border: "" } }, [
                        _vm._v("启用")
                      ]),
                      _c("el-radio", { attrs: { label: 2, border: "" } }, [
                        _vm._v("禁用")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "视频封面", prop: "pic" }
                },
                [
                  _c("uploadImage", {
                    ref: "picUploadImage",
                    attrs: { limit: 1, "file-list": _vm.picfileList },
                    on: {
                      change: function($event) {
                        return _vm.picUrl($event)
                      },
                      delUrl: function($event) {
                        return _vm.delUrl($event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "视频", prop: "video" }
                },
                [
                  _c("uploadVedio", {
                    ref: "uploadVedio",
                    attrs: { limit: 1, VideoPath: _vm.form.video },
                    on: { Change: _vm.getUrlVideo }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }